import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c329292"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-flex"} }, "主单信息", -1))
const _hoisted_2 = { class: "form-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  colspan: "10",
  class: "containers"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "箱号", -1))
const _hoisted_7 = { colspan: "10" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "附件", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_order_detail_company_business_card = _resolveComponent("order-detail-company-business-card")!
  const _component_order_detail_products_summary = _resolveComponent("order-detail-products-summary")!
  const _component_order_detail_container = _resolveComponent("order-detail-container")!
  const _component_order_detail_lading_bill = _resolveComponent("order-detail-lading-bill")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createBlock(_component_miezz_card, {
    toggle: true,
    topButtons: _ctx.topButtons,
    onHandleHeaderButtonClick: _ctx.handleClick
  }, {
    headerLeft: _withCtx(() => [
      _hoisted_1,
      (_ctx.form.Data)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            style: {"display":"inline-flex","margin":"0px","font-size":"14px"},
            label: "业务所属周期",
            prop: "BusinessCycle",
            "label-width": "141px"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatMonth(_ctx.form.Data?.BusinessCycle)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.form.Data?.CargoQuantity)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            style: {"display":"inline-flex","margin":"0px","font-size":"14px"},
            prop: "CargoQuantity",
            "label-width": "50px"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.Data?.CargoQuantity), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.form.Data)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            model: _ctx.form.Data,
            ref: "ruleForm",
            "label-width": "200px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_order_detail_company_business_card, {
                  form: _ctx.form,
                  "onUpdate:form": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Master Bill No.",
                      prop: "MasterBillNo"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.MasterBillNo ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "House Bill No.",
                      prop: "HouseBillNo"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.HouseBillNo ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Port of  Loading/装货港",
                      prop: "LoadingPortId"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.LoadingPortLabel ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Port of Discharge/卸货港",
                      prop: "DischargePortId"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.DischargePortLabel ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Port of Delivery/目的港",
                      prop: "DeliveryPortId"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPortLabel ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Place of Delivery/交货地点",
                      prop: "DeliveryPlaceLabel"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPlaceLabel ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "承运人",
                      prop: "CarrierId"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.CarrierLabel ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "合约号",
                      prop: "ContractNo"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.ContractNo ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "船名",
                          prop: "ShipName"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.form.Data.ShipName ?? "暂无数据"), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          label: "航次",
                          prop: "VoyageNumber"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.form.Data.VoyageNumber ?? "暂无数据"), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Air)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 2,
                          label: "航班",
                          prop: "Flight"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.form.Data.Flight ?? "暂无数据"), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 3,
                          label: "班次",
                          prop: "RailwayNumber"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.form.Data.RailwayNumber ?? "暂无数据"), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, {
                      label: "装货港ETD",
                      prop: "EstimatedDepartureDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedDepartureDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "装货港ATD",
                      prop: "ActualDepartureDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.ActualDepartureDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "目的港ETA",
                      prop: "EstimatedArrivalDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedArrivalDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "目的港ATA",
                      prop: "ActualArrivalDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.ActualArrivalDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "舱单截止时间",
                      prop: "ManifestEndDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.ManifestEndDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "截关时间",
                      prop: "CustomsEndDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.CustomsEndDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "开港时间",
                      prop: "OpenPortDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.OpenPortDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "截港时间",
                      prop: "PortEndDate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.PortEndDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "挂靠码头",
                      prop: "GoodsTransportType"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.Data.Dock ?? "暂无数据"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "运费支付方式",
                      prop: "TransportPaymentType"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatTransportPaymentType()), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "运输类型",
                      prop: "GoodsTransportType"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatGoodsTransportType()), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["form"]),
                _createVNode(_component_order_detail_products_summary, {
                  form: _ctx.form,
                  "onUpdate:form": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form) = $event))
                }, null, 8, ["form"]),
                (
            _ctx.form.Data.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          )
                  ? (_openBlock(), _createBlock(_component_order_detail_container, {
                      key: 0,
                      form: _ctx.form,
                      "onUpdate:form": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form) = $event)),
                      showSealNumbers: 
            _ctx.form.Data?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          ,
                      departurePortContainer: _ctx.form.Data?.OpenDeparturePortContainer
                    }, null, 8, ["form", "showSealNumbers", "departurePortContainer"]))
                  : _createCommentVNode("", true),
                (
            _ctx.form.Data.TransportContainerLoad == _ctx.EnumTransportContainerLoad.LCL
          )
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                      _createElementVNode("td", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", null, _toDisplayString(_ctx.form.Data.ContainerNo), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_order_detail_lading_bill, {
                  form: _ctx.form,
                  "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form) = $event))
                }, null, 8, ["form"])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, [
                    _createVNode(_component_miezz_upload, {
                      modelValue: _ctx.form.Data.Files,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.Files) = $event)),
                      prop: "File",
                      preview: true
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["topButtons", "onHandleHeaderButtonClick"]))
}